<template>
    <div class="act">
        <div style="position:relative;">
            <img src="https://cdn-yp.yymedias.com/public/APP/img/Activity/1111/bg1.png"/>
        </div>
        <div style="position:relative;">
            <div class="btn1 boo-center-v" @click="doActivity(80)">&nbsp;</div>
            <div class="btn2 boo-center-v" @click="doActivity(81)">&nbsp;</div>
            <div class="btn3 boo-center-v" @click="doActivity(82)">&nbsp;</div>
            <div class="btn4 boo-center-v" @click="doActivity(83)">&nbsp;</div>
            <img src="https://cdn-yp.yymedias.com/public/APP/img/Activity/1111/bg2.png"/>
        </div>
        <div style="position:relative;">
            <div class="chou-click" @click="chou()"></div>
            <div class="chou-tips">
                <yd-rollnotice autoplay="2000" v-if="giftList.length > 0" align="center">
                    <yd-rollnotice-item v-for="gift in giftList">{{gift.user}}拆中了{{giftConf[gift.gift]}}</yd-rollnotice-item>
                </yd-rollnotice>
                <span v-else style="line-height: .7rem">福袋来袭，幸运指数飙升</span>
            </div>
            <div class="chou-times">福袋个数：<span>{{times}}</span></div>
            <div class="chou-his" v-if="hisList.length > 0" @click="histListFlag=true">
                获奖记录 : <span v-for="his in top(hisList)">{{giftConf[his.gift]}}</span>
            </div>
            <img src="https://cdn-yp.yymedias.com/public/APP/img/Activity/1111/bg3.png"/>
        </div>
        <div style="position:relative;">
            <div class="btn5 boo-center-v" @click="doActivity(84)">&nbsp;</div>
            <img src="https://cdn-yp.yymedias.com/public/APP/img/Activity/1111/bg4.png"/>
        </div>

        <yd-popup v-model="successMsgFlag" position="center" width="80%" :close-on-masker="false">
            <div class="msg-box">
                <div class="msg-info">
                    <img :src="'https://cdn-yp.yymedias.com/public/APP/img/Activity/1111/gift'+rstGift+'.png'"/>
                    <div class="msg-txt" v-if="rstGift == 0">
                        哎呀，福袋小惊喜溜走了，祝您下次好运
                    </div>
                    <div class="msg-txt" v-else>
                        恭喜你拆到{{giftConf[rstGift]}}，请再接再厉
                        <p v-if="rstGift == 4 || rstGift == 6" style="font-size: .8em">(请添加客服微信：<span style="color:#FFDE8F">dfacf222</span> 领取奖励)</p>
                    </div>
                </div>
                <div class="msg-close"><yd-icon @click.native="successMsgFlag=false" name="error-outline" size="1rem" color="#fff"></yd-icon></div>
            </div>
        </yd-popup>

        <yd-popup v-model="histListFlag" position="left" width="80%">
            <yd-timeline>
                <yd-timeline-item v-for="his in hisList">
                    <p>拆中 <span style="font-weight: bold;">【{{giftConf[his.gift]}}】</span></p>
                    <p v-if="his.gift == 4 || his.gift == 6" style="font-size: .8em">(请添加客服微信：<span style="color:#ef4f4f;">dfacf222</span> 领取奖励)</p>
                    <p style="margin-top: 10px; font-size: .8em;">{{his.time}}</p>
                </yd-timeline-item>
            </yd-timeline>
        </yd-popup>
    </div>
</template>

<script>
    import { fetch } from '@/api/appRequest.js';
    import API from '@/api/app.conf.js';
    export default {
        name: "normal",
        data(){
            return {
                ActivityId : 0,
                times:0,
                successMsgFlag: false,
                rstGift:0,
                requeryTimes:5,
                hisList:[],histListFlag:false,
                giftList:[],
                giftConf:['谢谢参与','50金币', '1天VIP', '7天VIP', '11.11现金红包', '30天VIP', '有影的茶', '年费会员']
            };
        },
        created(){
            document.title = '双十一';
            this.initData();
            for (let a in this.giftConf) {  // 先加载图片
                let img = new  Image();
                img.src = 'https://cdn-yp.yymedias.com/public/APP/img/Activity/1111/gift'+a+'.png';
            }
        },
        methods :{
            top: function (numbers) {
                return numbers.filter(function (number, index) {
                    return index <5;
                })
            },
            chou(){
                if(this.times<=0) {
                    this.$dialog.alert({mes:'福袋数量不足，仅本活动充值可赢取福袋哦。'}); return;
                }
                this.$dialog.loading.open('正在拆开...');
                fetch(API.U('luck_draw')).then(res => {
                    this.$dialog.loading.close();
                    if (res.status_code == 200) {
                        // 抽奖情况
                        console.log('抽奖结果',res.data);
                        this.rstGift = res.data;
                        this.successMsgFlag = true;
                        this.hisList.unshift({gift:res.data, time:"刚刚"});
                        this.times --;
                    } else {
                        this.$dialog.alert({mes:'code:' + res.status_code + '错误' + res.message});
                    }
                }).catch((err) => {
                    this.$dialog.loading.close();
                    this.$dialog.alert({mes:'请求失败3：' + err});
                })
            },
            getTimes(){
                return new Promise((resolve, reject) => {
                    fetch('luck_draw_num').then(res => {
                        if (res.status_code == 403) {
                            this.$dialog.alert({
                                mes: "请先登录", callback: () => {
                                    this.$yymd.yy2c('{"a":12,"v":1,"p":{}}', 1)
                                }
                            })
                        } else if (res.status_code == 200) {
                            this.times = parseInt(res.data);
                            console.log('次数',res.data);
                            resolve()
                        } else {
                            reject('code:' + res.status_code + '错误' + res.message)
                        }
                    }).catch((err) => {
                        reject('请求失败3：' + err)
                    })
                });
            },
            initData(){
                this.$dialog.loading.open('正在加载必要零部件...');
                let data = new Promise((resolve, reject) => {
                    fetch('luck_draw_data').then(res => {
                        if (res.status_code == 403) {
                            this.$dialog.alert({
                                mes: "请先登录", callback: () => {
                                    this.$yymd.yy2c('{"a":12,"v":1,"p":{}}', 1)
                                }
                            })
                        } else if (res.status_code == 200) {
                            let data = JSON.parse(decodeURIComponent(res.data.replace(/\+/g, '%20')))
                            // console.log('数据',data);
                            this.hisList = data.user_win;
                            this.giftList = data.win_show;
                            resolve()
                        } else {
                            reject('code:' + res.status_code + '错误' + res.message)
                        }
                    }).catch((err) => {
                        reject('请求失败3：' + err)
                    })
                });

                Promise.all([data, this.getTimes()]).then(res => {
                    this.$dialog.loading.close();
                }).catch(err => {
                    this.$dialog.alert({ mes: err, callback: () => { } })
                    console.log(err)
                })
            },
            doActivity(goodsId){
                this.$dialog.loading.open('');
                this.$yymd.pay({
                    payid:goodsId,
                    success : (tradeNo)=>{
                        this.$dialog.loading.close();
                        this.$dialog.alert({mes:'充值成功'});
                        this.$dialog.loading.open('正在获取福袋...');
                        this.getTimes().then(res=>{
                            this.$dialog.loading.close();
                        }).catch(err=>{
                            console.log(err);
                            this.$dialog.alert({
                                mes: "获取福袋发生延迟，请重新进入该活动。", callback: () => {
                                    this.$yymd.yy2c('{"a":12,"v":1,"p":{}}', 1)
                                }
                            });
                        });
                    },
                    error : (obj)=>{
                        this.$dialog.loading.close();
                        try{
                            obj = JSON.parse(obj);
                            if (obj.stats_code == 200) {
                                this.$dialog.alert({mes:'充值失败'});
                            } else {
                                this.$dialog.alert({mes:obj.message});
                            }
                        }catch (e) {
                            this.$dialog.alert({mes:'充值失败'});
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .act {position: relative; margin:0 auto; min-width:320px; max-width:750px;background-color: #A4231E;}
    .act img {max-width: 100%;}
    .btn1{
        position: absolute;
        left: 57%;
        width: 28%;
        height: 10%;
        top: 26.3%;
    }
    .btn2{
        position: absolute;
        left: 57%;
        width: 28%;
        height: 10%;
        top: 44%;
    }
    .btn3{
        position: absolute;
        left: 57%;
        width: 28%;
        height: 10%;
        top: 61%;
    }
    .btn4{
        position: absolute;
        left: 57%;
        width: 28%;
        height: 10%;
        top: 78%;
    }
    .btn5{
        position: absolute;
        left: 38%;
        width: 31%;
        height: 6%;
        top: 27%;
    }

    .msg-txt {
        font-size:.3rem; line-height: 2em; color:#fff;
        text-align: center;
        padding-top: .4rem;
    }
    .msg-box {
        position:relative;
    }
    .msg-info {
        padding:.6rem .3rem; border-radius: .2rem;
        background-color:#A4231E;
        border:2px solid #FFDE8F;
        border-radius: .2rem;
        text-align: center;
    }
    .msg-info img { height: 2.8rem;}
    .msg-close {
        padding:.3rem; text-align: center;
    }

    .chou-click {
        position:absolute;
        top: 47%;
        left: 45%;
        width: 27%;
        height: 22%;
        background: url('https://cdn-yp.yymedias.com/public/APP/img/Activity/1111/click.gif') no-repeat center;
        background-size:100% 100%;
    }
    .chou-tips {
        position:absolute;
        top: 21%;
        left: 10%;
        width: 80%;
        font-size: .3rem;
        color:#FFF324;
        text-align: center;
    }
    .chou-tips .yd-rollnotice {
        background-color:transparent;
    }
    .chou-times {
        position:absolute;
        top: 82%;
        left: 3.72%;
        width: 92.78%;
        height: 7%;
        font-size: .3rem;
        color:#FFF324;
        text-align: center;
    }
    .chou-his {
        position:absolute;
        top: 88.8%;
        left: 7.72%;
        width: 84.78%;
        height: 7%;
        font-size: .3rem;
        color:#FFF324;
        line-height: 250% ;
        text-align: left;
        overflow: hidden;
    }
    .chou-his span {
        padding:0 .1rem; border-right:1px solid #FFF324;
    }
    .chou-his span:last-child {
        border: 0;
    }
    .chou-times span{font-weight: 900;}
</style>